import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {LoadingService} from '../services/loading.service';

let count = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  count++;
  loadingService.setLoadingStatus(true);

  return next(req).pipe(
    finalize(() => {
      count--;
      if (count === 0) {
        loadingService.setLoadingStatus(false);
      }
    }),
  );
};
